import * as React from "react";

import { DataSourceCheckoutRegionsQueryProvider } from "./data-source-checkout-regions-query";

export const DataSourceCheckoutRegionsProvider =
  DataSourceCheckoutRegionsQueryProvider;
